import React, { useState, useContext, useEffect } from 'react'
import { SectionBlock, SlideModal } from '..'
import PageLoader from 'Lib/Pageloader'
import {
  fireClevertapEvent
} from 'AccountsUtils'
import CaseHistoryCard from './CaseHistoryCards'
import SupportWidget from '../../components/Support/SupportWidget'
import { AccountsContext } from '../../context'

const CaseHistoryDetails = props => {
  const { slideModalFlag, setOpenCaseList, isPWA, subHeader,
    caseData, tripId, setRefetchCases, refetchCases, verticalName } = props
  const [disableBg, setDisableBg] = useState(false)
  const { openModal } = useContext(AccountsContext)

  const openSupportModalHandler = e => {
    fireClevertapEvent('Raise_a_new_request_clicked', { trip_id: tripId })
    openModal()
  }

  const slideModalClose = e => {
    setOpenCaseList(false)
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0]) {
      ele[0].classList.remove('overflow-hidden')
      window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' })
    }
  }

  useEffect(() => {
    fireClevertapEvent('support_requests_page_viewed', { trip_id: tripId })
  }, [])

  return (
    <React.Fragment>
      <SlideModal
        header="Trip support requests"
        open={slideModalFlag}
        subHeader={subHeader}
        headerType="page"
        subHeaderClass="tt-first-caps"
        onCloseClick={e => slideModalClose(e)}
        bodyClass="h-100p overflow-y"
        addAlertOverlayClass={disableBg ? 'alertOverlay' : ''}
        caseToggle={true}
        fullContent={slideModalFlag}
      >
        <SectionBlock header="Support Requests" isPWA={isPWA} />
        <If condition={refetchCases}>
          <PageLoader className={`${isPWA ? '' : 'modal-loader'}`} title="Fetching Case Details" message="Please wait while we are updating case details." />
          <Else />
          <React.Fragment>
            <div className="border-bottom-grey">
              <CaseHistoryCard
                tripId={tripId}
                caseData={caseData}
                setRefetchCases={setRefetchCases}
                setDisableBg={setDisableBg}
                isPWA={isPWA}
              />
            </div>
            <button
              id="caseCreation"
              type="button"
              className="fs-15 my-10 tt-sentence bg-white c-blue ta-c p-4 bn bt w-100p"
              onClick={ e => { openSupportModalHandler(e) }}
            >
        Raise a new request
            </button>
            <SupportWidget setRefetchCases={setRefetchCases} verticalName={verticalName} />
          </React.Fragment>
        </If>
      </SlideModal>
    </React.Fragment>
  )
}
export default CaseHistoryDetails
